import React from 'react'
import { isNil } from 'ramda'
import styled from 'styled-components'
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Chart,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { STYLES } from '../../static/style'
import { SchoolChartTitle } from './SchoolChartTitle'

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const StyledSchoolChart = styled.div``

interface ISchoolChartProps {
  title: string
  fieldName: string
  color?: string
  results?: object
  className?: string
  options?: object
}

const SchoolChart: React.FC<ISchoolChartProps> = ({
  title,
  results,
  fieldName,
  options = {
    plugins: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      bezierCurve: false,
      tooltipTemplate: '<%= value %>',
    },
  },
  className,
  color = STYLES.PRIMARY_COLOR,
}) => {
  if (!results) {
    return null
  }
  const years = Object.keys(results)
  const displayYears = []
  const yearData = []
  years.forEach((y) => {
    const value = results[y][fieldName]
    if (!isNil(value)) {
      displayYears.push(y)
      yearData.push(results[y][fieldName])
    }
  })
  if (displayYears.length < 2) {
    return null
  }
  const data = {
    labels: displayYears,
    datasets: [
      {
        label: title,
        fill: false,
        lineTension: 0.1,
        backgroundColor: color,
        borderColor: color,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: `${color}EE`,
        pointBackgroundColor: STYLES.COLOR_WHITE,
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: `${color}EE`,
        pointHoverBorderColor: `${color}EE`,
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: yearData,
      },
    ],
  }
  return (
    <StyledSchoolChart className={className}>
      <SchoolChartTitle>{title}</SchoolChartTitle>
      <Line data={data} options={options} />
    </StyledSchoolChart>
  )
}

export { SchoolChart }
